/* @flow */

import {useQuery} from '@apollo/react-hooks';
import {NetworkStatus} from 'apollo-client';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetYearOverviewStats as GetYearOverviewStatsQuery,
    GetYearOverviewStats_quotaYearOverview as QuotaYearOverview,
    GetYearOverviewStatsVariables,
} from 'nutshell-graphql-types';

import GET_YEAR_OVERVIEW_STATS from '../queries/get-year-overview-stats.graphql';

export const useGetYearOverviewStats = (
    fiscalYears: number[]
): {
    quotaYearOverview: QuotaYearOverview[] | null | undefined;
    isLoading: boolean;
    isRefetching: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetYearOverviewStatsQuery,
        GetYearOverviewStatsVariables
    >(GET_YEAR_OVERVIEW_STATS, {
        variables: {
            fiscalYears,
        },
        notifyOnNetworkStatusChange: true,
    });

    return {
        quotaYearOverview: data && data.quotaYearOverview,
        isLoading: loading && networkStatus !== NetworkStatus.refetch,
        isRefetching: networkStatus === NetworkStatus.refetch,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
